// import { categoriesReducer } from './categoriesReducers';
// // import { authenticationReducer, defaultReducer, registrationReducer, loginReducer, logoutReducer, State } from './authenticationReducer';
// import { loginReducer, defaultReducer, State } from './authenticationReducer';
// import { userReducer} from './userReducers';
// import { buyerReducer} from './buyerReducers';
// import { sellerReducer} from './sellerReducers';
// import * as auth from './authenticationReducer';
// import { createFeatureSelector } from '@ngrx/store';


// export interface AppState {
//   authState: State
// }



// export const reducers = {
//   categoriesReducer: categoriesReducer,
//   // authenticationReducer: authenticationReducer,
//   defaultReducer: defaultReducer,
//   // registrationReducer:registrationReducer,
//   loginReducer: loginReducer,
//   // logoutReducer: logoutReducer,
//   userReducer:userReducer,
//   buyerReducer:buyerReducer,
//   sellerReducer:sellerReducer

// }


// export const selectAuthState = createFeatureSelector<AppState>('auth');


import { createFeatureSelector } from '@ngrx/store';
import * as auth from './authenticationReducer';
import * as seller from './sellerReducers';
import * as buyer from './buyerReducers';
import * as user from './userReducers';
import * as announcement from './announcementReducers';
import * as categories from './categoriesReducers';
import * as offer from './offerReducers';



export interface AppState {
  authState: auth.State;
}
export interface SellerState {
  sellerState: seller.State;
}
export interface buyerState {
  buyerState: buyer.State;
}
export interface userState {
  userState: user.State;
}
export interface announcementState {
  announcementState: announcement.State
}
export interface categoriesState {
  categoriesState: categories.State
}
export interface offerState {
  offerState: offer.State
}
export const reducers = {
  auth: auth.reducer,
  seller: seller.sellerReducer,
  buyer: buyer.buyerReducer,
  user: user.userReducer,
  announcement: announcement.announcementReducer,
  categories :categories.categoriesReducer,
  offer: offer.offerReducer,
};
// export const sellerReducer = {

// };
export const selectAuthState = createFeatureSelector<AppState>('auth');
export const selectsellerState = createFeatureSelector<SellerState>('seller');
export const selectbuyerState = createFeatureSelector<buyerState>('buyer');
export const selectuserState = createFeatureSelector<userState>('user');
export const selectAnnouncementState = createFeatureSelector<announcementState>('announcement');
export const selectCategoriesState = createFeatureSelector<categoriesState>('categories');
export const selectOfferState = createFeatureSelector<offerState>('offer');



 
